import { CART_TYPE } from "../constants";

const cartReducer = (state = {
   cartItems: []
}, action) => {
   switch (action.type) {
      case CART_TYPE.FETCH:
         return {
            ...state,
            ...action.payload
         };
      case CART_TYPE.CHANGE_QUANTITY:
         return {
            ...state,
            cartItems: state?.cartItems?.map((m) => {
               if (m.item_key == action.payload.id) {
                  return action.payload.data;
               }
               return m;
            })
         };
      case CART_TYPE.CHANGE_VALUE:
         return {
            ...state,
            [action.payload.key]: action.payload.value
         }
      default:
         return state;
   }
};

export default cartReducer;